import { Modal } from '@ui';
import { memo, useState } from 'react';
import ReviewProductModalComp from './component';

const ReviewProductModal = props => {
  const { initialCurrentFormState, isBackButton = true, onCloseModal } = props;
  const [currentFormState, setCurrentFormState] = useState(
    initialCurrentFormState ?? 0
  );

  const showBack = isBackButton && currentFormState > 0;
  const onBack = () => {
    setCurrentFormState(prev => (prev > 0 ? prev - 1 : 0));
  };

  return (
    <Modal
      className='fromMd:w-[550px] fromMd:max-w-[550px] fromMd:min-h-[536px] sm:w-full sm:min-h-[356px] flex flex-col items-center justify-center'
      framed
      placementMobile='bottom-sheet'
      onClose={onCloseModal}
      onBack={showBack ? onBack : undefined}
    >
      <ReviewProductModalComp
        {...props}
        currentFormState={currentFormState}
        setCurrentFormState={setCurrentFormState}
      />
    </Modal>
  );
};

export default memo(ReviewProductModal);
